/** 判断与执行声明编辑文案；引擎标识仍按协议原文显示。 */
export const TRIGGERS_ZH = {
  'triggers.selectedRule': '当前规则',
  'triggers.structured': '可视编辑',
  'triggers.open': '编辑行为规则',
  'triggers.backToSettings': '返回本层参数',
  'triggers.label.text': '文本',
  'triggers.label.phase': '阶段',
  'triggers.label.source': '消息来源',
  'triggers.label.count': '事件计数',
  'triggers.label.names': '名称名单',
  'triggers.label.session': '会话状态',
  'triggers.label.preset': '当前模块',
  'triggers.label.any': '任意条件满足',
  'triggers.label.all': '全部条件满足',
  'triggers.label.not': '条件不满足',
  'triggers.label.notAny': '所有条件不满足',
  'triggers.label.inject-text': '注入文本',
  'triggers.label.assembly': '调整装配',
  'triggers.label.decision': '工具裁决',
  'triggers.label.append-context': '追加上下文',
  'triggers.label.guard': '执行防护',
  'triggers.label.sdk-strip': '裁剪工具声明',
  'triggers.label.request-params': '请求参数',
  'triggers.label.inbox-prepend': '前置收件消息',
  'triggers.label.pre-step-filter': '过滤注入消息',
  'triggers.label.default': '默认位置',
  'triggers.label.outermost': '最外层',
  'triggers.label.subject': '匹配对象',
  'triggers.label.keys': '关键词',
  'triggers.label.promoted': '已晋升',
  'triggers.label.kind': '来源类型',
  'triggers.label.of': '统计事件',
  'triggers.label.per': '计数窗口',
  'triggers.label.min': '最小次数',
  'triggers.label.max': '最大次数',
  'triggers.label.allow': '允许名单',
  'triggers.label.deny': '拒绝名单',
  'triggers.label.type': '事件类型',
  'triggers.label.present': '事件已存在',
  'triggers.label.presetId': '模块标识',
  'triggers.label.config': '提示词配置',
  'triggers.label.id': '标识',
  'triggers.label.layer': '插入点',
  'triggers.label.modelScope': '模型范围',
  'triggers.label.target': '目标',
  'triggers.label.sections': '系统段',
  'triggers.label.add': '添加',
  'triggers.label.mode': '执行方式',
  'triggers.label.mask': '工具过滤',
  'triggers.label.reason': '拒绝原因',
  'triggers.label.patch': '参数覆盖',
  'triggers.label.maxTokens': '输出上限',
  'triggers.label.blockPlugins': '屏蔽来源',
  'triggers.label.channelOrder': '通道内顺序',
  'triggers.title': '判断 → 执行',
  'triggers.hint': '为当前模块定义何时判断、满足什么条件、执行什么动作。主会话与子代理共享这些规则，受众由规则自身决定。',
  'triggers.count': '{count} 条规则',
  'triggers.empty': '还没有行为规则。选择一个动作作为起点，再按需添加条件。',
  'triggers.create': '新建规则',
  'triggers.duplicate': '复制规则',
  'triggers.delete': '删除规则',
  'triggers.deleteHint': '删除 {id} 的草稿；保存后才从模块移除。',
  'triggers.discard': '放弃本地修改',
  'triggers.discardHint': '放弃未保存的规则和字段输入；存在远端冲突时改用已读取的远端规则。',
  'triggers.cancel': '取消',
  'triggers.reload': '重新读取',
  'triggers.validate': '校验规则',
  'triggers.save': '保存规则',
  'triggers.saved': '规则已保存',
  'triggers.validated': '规则校验通过，尚未保存',
  'triggers.dirty': '有未保存修改',
  'triggers.clean': '已与模块同步',
  'triggers.loading': '正在读取规则…',
  'triggers.saving': '正在保存…',
  'triggers.failed': '规则操作失败，请重新读取或重试。',
  'triggers.conflict': '模块已发生变化。本地输入已保留，请重新读取；规则本身存在冲突时不会自动覆盖。',
  'triggers.remoteConflict': '磁盘中的规则也已修改。本地草稿已保留；可复制高级声明备份，再放弃本地修改以读取远端版本。',
  'triggers.invalidJson': '请输入有效的 JSON 对象或数组，并与此字段的结构一致。',
  'triggers.fixDrafts': '请先修正未完成的字段；其原始输入已保留。',
  'triggers.advanced': '完整声明 · JSON',
  'triggers.id': '规则标识',
  'triggers.when': '判断条件',
  'triggers.unconditional': '无条件',
  'triggers.conditionType': '条件类型',
  'triggers.conditionJson': '完整判断条件',
  'triggers.action': '执行动作',
  'triggers.actionType': '动作类型',
  'triggers.actionJson': '完整动作参数',
  'triggers.multiActions': '动作序列 · JSON',
  'triggers.channel': '执行通道',
  'triggers.phase': '执行阶段',
  'triggers.order': '通道内顺序',
  'triggers.waterfall': '通道注册位置',
  'triggers.unsupportedWhen': '此动作不支持顶层判断条件。请在动作自身支持的配置中限制作用范围；已有条件须手动移除。',
  'triggers.removeWhen': '移除顶层条件',
  'triggers.complex': '嵌套条件与多动作使用 JSON 编辑，保存前由引擎完整校验。',
  'triggers.executionHint': '动作类型会填入默认执行点。修改动作内部的 phase、mode 或 layer 后，请同步核对通道与阶段；校验会拒绝不一致配置。',
  'triggers.parameter': '参数 · {name}',
  'triggers.number': '请输入有限数值。',
  'triggers.listHint': '每行一个值，空白表示空列表。',
} as const

export const TRIGGERS_EN: Record<keyof typeof TRIGGERS_ZH, string> = {
  'triggers.selectedRule': 'Selected rule',
  'triggers.structured': 'Visual editor',
  'triggers.open': 'Edit behavior rules',
  'triggers.backToSettings': 'Back to layer parameters',
  'triggers.label.text': 'Text',
  'triggers.label.phase': 'Phase',
  'triggers.label.source': 'Message source',
  'triggers.label.count': 'Event count',
  'triggers.label.names': 'Name list',
  'triggers.label.session': 'Session state',
  'triggers.label.preset': 'Current module',
  'triggers.label.any': 'Any condition matches',
  'triggers.label.all': 'All conditions match',
  'triggers.label.not': 'Condition does not match',
  'triggers.label.notAny': 'No conditions match',
  'triggers.label.inject-text': 'Inject text',
  'triggers.label.assembly': 'Adjust assembly',
  'triggers.label.decision': 'Tool decision',
  'triggers.label.append-context': 'Append context',
  'triggers.label.guard': 'Execution guard',
  'triggers.label.sdk-strip': 'Strip tool declarations',
  'triggers.label.request-params': 'Request parameters',
  'triggers.label.inbox-prepend': 'Prepend inbox message',
  'triggers.label.pre-step-filter': 'Filter injected messages',
  'triggers.label.default': 'Default position',
  'triggers.label.outermost': 'Outermost',
  'triggers.label.subject': 'Match subject',
  'triggers.label.keys': 'Keywords',
  'triggers.label.promoted': 'Promoted',
  'triggers.label.kind': 'Source kind',
  'triggers.label.of': 'Counted event',
  'triggers.label.per': 'Count window',
  'triggers.label.min': 'Minimum count',
  'triggers.label.max': 'Maximum count',
  'triggers.label.allow': 'Allowed names',
  'triggers.label.deny': 'Denied names',
  'triggers.label.type': 'Event type',
  'triggers.label.present': 'Event present',
  'triggers.label.presetId': 'Module ID',
  'triggers.label.config': 'Prompt configuration',
  'triggers.label.id': 'Identifier',
  'triggers.label.layer': 'Insertion point',
  'triggers.label.modelScope': 'Model scope',
  'triggers.label.target': 'Target',
  'triggers.label.sections': 'System sections',
  'triggers.label.add': 'Add',
  'triggers.label.mode': 'Execution mode',
  'triggers.label.mask': 'Tool filter',
  'triggers.label.reason': 'Denial reason',
  'triggers.label.patch': 'Parameter overrides',
  'triggers.label.maxTokens': 'Output limit',
  'triggers.label.blockPlugins': 'Blocked sources',
  'triggers.label.channelOrder': 'Order within channel',
  'triggers.title': 'Condition → Action',
  'triggers.hint': 'Define when to evaluate, what to match, and what to do for this module. Main and delegated sessions share these rules; each rule defines its audience.',
  'triggers.count': '{count} rules',
  'triggers.empty': 'No behavior rules yet. Choose an action, then add conditions as needed.',
  'triggers.create': 'New rule',
  'triggers.duplicate': 'Duplicate rule',
  'triggers.delete': 'Delete rule',
  'triggers.deleteHint': 'Remove draft {id}; the module changes only after saving.',
  'triggers.discard': 'Discard local changes',
  'triggers.discardHint': 'Discard unsaved rules and field input. If a remote conflict exists, use the remote rules already loaded.',
  'triggers.cancel': 'Cancel',
  'triggers.reload': 'Reload',
  'triggers.validate': 'Validate rules',
  'triggers.save': 'Save rules',
  'triggers.saved': 'Rules saved',
  'triggers.validated': 'Rules validated; not saved yet',
  'triggers.dirty': 'Unsaved changes',
  'triggers.clean': 'Synced with module',
  'triggers.loading': 'Loading rules…',
  'triggers.saving': 'Saving…',
  'triggers.failed': 'Rule operation failed. Reload or retry.',
  'triggers.conflict': 'The module changed. Your input is preserved. Reload to compare; conflicting rules will not be overwritten automatically.',
  'triggers.remoteConflict': 'The rules on disk also changed. Your draft is preserved. Copy the advanced declaration as a backup, then discard local changes to use the remote version.',
  'triggers.invalidJson': 'Enter a valid JSON object or array matching this field’s structure.',
  'triggers.fixDrafts': 'Correct unfinished fields first; their original input is preserved.',
  'triggers.advanced': 'Full declaration · JSON',
  'triggers.id': 'Rule ID',
  'triggers.when': 'Condition',
  'triggers.unconditional': 'Unconditional',
  'triggers.conditionType': 'Condition type',
  'triggers.conditionJson': 'Full condition',
  'triggers.action': 'Action',
  'triggers.actionType': 'Action type',
  'triggers.actionJson': 'Full action parameters',
  'triggers.multiActions': 'Action sequence · JSON',
  'triggers.channel': 'Execution channel',
  'triggers.phase': 'Execution phase',
  'triggers.order': 'Channel order',
  'triggers.waterfall': 'Registration position',
  'triggers.unsupportedWhen': 'This action does not support a top-level condition. Limit its scope using supported action options; remove any existing condition explicitly.',
  'triggers.removeWhen': 'Remove top-level condition',
  'triggers.complex': 'Edit nested conditions and multiple actions as JSON. The engine validates the full declaration before saving.',
  'triggers.executionHint': 'Choosing an action fills its default execution point. After changing its phase, mode, or layer, check the channel and phase; validation rejects mismatches.',
  'triggers.parameter': 'Parameter · {name}',
  'triggers.number': 'Enter a finite number.',
  'triggers.listHint': 'One value per line; leave blank for an empty list.',
}
